"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// tslint:disable:deprecation
var React = require("react");
var TypeStyle = require("typestyle");
var BrowserDetection_1 = require("../../utils/BrowserDetection");
var DomUtil_1 = require("../../utils/DomUtil");
var InteractiveDom_1 = require("../../utils/InteractiveDom");
var TextFieldBase_1 = require("./TextFieldBase");
var isMSFT = BrowserDetection_1.isIE || BrowserDetection_1.isEdge;
var inputClass = !isMSFT ? '' : TypeStyle.style({
    $nest: {
        '&:focus': { backgroundColor: 'transparent' },
        '&::-ms-clear': { $unique: true, display: 'none' } // This prevents IE from adding a clear button to text inputs
    }
});
var Style = Object.freeze({
    WebkitAppearance: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    width: '100%',
});
var TextFieldInputWidget = /** @class */ (function (_super) {
    tslib_1.__extends(TextFieldInputWidget, _super);
    function TextFieldInputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComposing = false;
        _this.enterDown = false;
        _this.escDown = false;
        _this.handleBlur = function (e) {
            var _a, _b;
            _this.enterDown = false;
            _this.escDown = false;
            e.relatedTarget = DomUtil_1.findBlurRelatedTarget(e); // polyfill since React refuses to :(
            (_b = (_a = _this.props).handleBlur) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleChange = function (e) {
            if (_this.props.disabled || !_this.props.handleChange) {
                return;
            }
            _this.props.handleChange(e.target.value, _this.isComposing);
        };
        _this.handleComposition = function (e) {
            if (e.type === 'compositionend') {
                _this.isComposing = false;
                _this.handleChange(e);
            }
            else {
                _this.isComposing = true;
            }
        };
        _this.handleFocus = function (e) {
            if (!_this.props.shouldSelectTextOnFocus || DomUtil_1.shouldIgnoreFocusEvent(e)) {
                return;
            }
            DomUtil_1.selectInputText(e.target);
        };
        _this.handleKeyDown = function (e) {
            if (_this.props.disabled || _this.isComposing) {
                return;
            }
            if (e.key === 'Enter' && _this.props.handleEnter) {
                _this.enterDown = true;
                return;
            }
            else if (e.key === 'Escape' && _this.props.handleEscape) {
                _this.escDown = true;
                return;
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };
        _this.handleKeyUp = function (e) {
            if (_this.props.disabled || _this.isComposing) {
                return;
            }
            if (e.key === 'Enter' && _this.enterDown && _this.props.handleEnter) {
                _this.enterDown = false;
                _this.props.handleEnter();
            }
            else if (e.key === 'Escape' && _this.escDown && _this.props.handleEscape) {
                _this.escDown = false;
                _this.props.handleEscape();
            }
            else if (_this.props.onKeyUp) {
                _this.props.onKeyUp(e);
            }
        };
        return _this;
    }
    TextFieldInputWidget.prototype.render = function () {
        var _a = this.props, className = _a.className, containerStyle = _a.containerStyle, handleActive = _a.handleActive, handleBlur = _a.handleBlur, handleChange = _a.handleChange, handleEnter = _a.handleEnter, handleEscape = _a.handleEscape, handleFocus = _a.handleFocus, handleHover = _a.handleHover, inputRef = _a.inputRef, inputStyle = _a.inputStyle, interactiveStyles = _a.interactiveStyles, onDarkBackground = _a.onDarkBackground, placeholder = _a.placeholder, placeholderStyle = _a.placeholderStyle, pointerClick = _a.pointerClick, pointerDoubleClick = _a.pointerDoubleClick, pointerDown = _a.pointerDown, pointerUp = _a.pointerUp, shouldSelectTextOnFocus = _a.shouldSelectTextOnFocus, testId = _a.testId, text = _a.text, type = _a.type, inputProps = tslib_1.__rest(_a, ["className", "containerStyle", "handleActive", "handleBlur", "handleChange", "handleEnter", "handleEscape", "handleFocus", "handleHover", "inputRef", "inputStyle", "interactiveStyles", "onDarkBackground", "placeholder", "placeholderStyle", "pointerClick", "pointerDoubleClick", "pointerDown", "pointerUp", "shouldSelectTextOnFocus", "testId", "text", "type"]);
        return (React.createElement("input", tslib_1.__assign({}, inputProps, { className: [className, inputClass].join(' '), "data-tb-test-id": testId + '-TextInput', onBlur: this.handleBlur, onChange: this.handleChange, onCompositionEnd: this.handleComposition, onCompositionStart: this.handleComposition, onCompositionUpdate: this.handleComposition, onFocus: this.handleFocus, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, ref: inputRef, style: tslib_1.__assign(tslib_1.__assign({}, Style), inputStyle), type: type, value: text })));
    };
    TextFieldInputWidget.defaultProps = {
        shouldSelectTextOnFocus: true,
        text: '',
        type: TextFieldBase_1.TextInputType.Text,
    };
    TextFieldInputWidget = tslib_1.__decorate([
        InteractiveDom_1.InteractiveDomHoCDecorator
    ], TextFieldInputWidget);
    return TextFieldInputWidget;
}(React.Component));
exports.TextFieldInputWidget = TextFieldInputWidget;
//# sourceMappingURL=TextFieldInputWidget.js.map